import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import CheckIcon from '@mui/icons-material/Check'
import { Chip, Stack, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

type Program = {
	direct: boolean
	beBrandExtendable: boolean
	bePlatform: boolean
	entegra: boolean
}

/**
 * UI control to choose a program to include/exclude.
 */
export default function Programs() {
	const { control } = useFormContext()

	return (
		<Controller
			name="programs"
			control={control}
			render={({ field: { onChange, value } }) => {
				const handleChange = (key: keyof Program) => {
					onChange({ ...value, [key]: !value[key] })
				}

				return <ProgramControlUI value={value} onChange={handleChange} />
			}}
		/>
	)
}

/**
 * Presentational component for rendering the Program UI.
 */
export function ProgramControlUI({
	value,
	onChange,
}: {
	value: Program
	onChange: (key: keyof Program) => void
}) {
	return (
		<Stack spacing={2} alignItems="center" direction="row">
			<Typography variant="body1">Include Programs</Typography>
			<ProgramChip label="Direct" id="direct" value={value?.direct} onChange={onChange} />
			<ProgramChip
				label="BE Brand Extendable"
				id="beBrandExtendable"
				value={value?.beBrandExtendable}
				onChange={onChange}
			/>
			<ProgramChip
				label="BE Platform"
				id="bePlatform"
				value={value?.bePlatform}
				onChange={onChange}
			/>
			<ProgramChip label="Entegra" id="entegra" value={value?.entegra} onChange={onChange} />
		</Stack>
	)
}

/**
 * Displays a chip for a program
 */
function ProgramChip({
	label,
	id,
	value,
	onChange,
}: {
	label: string
	id: keyof Program
	value: boolean
	onChange: (key: keyof Program) => void
}) {
	return (
		<Chip
			label={label}
			size="small"
			color={value ? 'success' : 'default'}
			icon={value ? <CheckIcon /> : <CancelOutlinedIcon />}
			onClick={() => onChange(id)}
			data-testid={`program-chip-${label.toLowerCase().replace(' ', '-')}`}
		/>
	)
}
